import { ref, watch } from 'vue'

interface UIState {
  sidebarCollapsed: boolean
}

const STORAGE_KEY = 'connect-ui'

const loadInitial = (): UIState => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw) {
      const parsed = JSON.parse(raw) as Partial<UIState>
      return {
        sidebarCollapsed: !!parsed.sidebarCollapsed
      }
    }
  } catch {}
  return { sidebarCollapsed: false }
}

export const uiState = ref<UIState>(loadInitial())

watch(uiState, (state) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
  } catch {}
})

export const toggleSidebar = () => {
  uiState.value = { ...uiState.value, sidebarCollapsed: !uiState.value.sidebarCollapsed }
}

const query = typeof window !== 'undefined' ? window.matchMedia('(max-width: 48rem)') : null

export const narrow = ref(query?.matches ?? false)

query?.addEventListener('change', (event) => {
  narrow.value = event.matches
})
